"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * `debounce` function is used to delay the execution of a provided function until after a specified time period has passed since the last time the debounced function was invoked.
 * The function is useful to optimize performance by limiting the rate at which a function is executed, especially in scenarios like handling user input events, scrolling, or resizing.
 * Additionally, the debounce function allows you to execute the function immediately on the first call (when leading is set to true), and it can be canceled manually using the `.cancel()` method.
 *
 * @example
 * ```ts
 * const debounced1 = debounce((val: number)=>{
 *   console.log('val', val);
 * }, 100);
 *
 * debounced1();
 * debounced1();
 * debounced1(); // invoke func after 100ms
 *
 * const debounced2 = debounce((val: number)=>{
 *   console.log('val', val);
 * }, 100, { leading:true });
 * debounced2(); // immediately invoked func
 * debounced2();
 * debounced2(); // invoked func after 100ms
 *
 
 * const debounced3 = debounce((val: number)=>{
 *   console.log('val', val);
 * }, 100);
 * debounced3();
 * debounced3();
 * debounced3.cancel(); // cancel func
 * ```
 */
function debounce(func, wait, options) {
    if (options === void 0) { options = { leading: false }; }
    var timeoutId;
    var debounced = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var callNow = options.leading && !timeoutId;
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(function () {
            timeoutId = undefined;
            if (!options.leading) {
                func.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
            }
        }, wait);
        if (callNow) {
            func.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
        }
    };
    debounced.cancel = function () {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = undefined;
        }
    };
    return debounced;
}
exports.default = debounce;
//# sourceMappingURL=debounce.js.map